import { useOrganization } from '@clerk/clerk-react';
import { AccountMenu } from '@flobi/asset-library/account';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { Icon } from '../editor/chrome/icons';

/** The workspace's mark: its picture, or its initial on a small square. */
function Mark({ name, imageUrl, hasImage }: { name: string; imageUrl?: string; hasImage?: boolean }) {
  if (imageUrl && hasImage) return <img src={imageUrl} alt="" className="size-[24px] shrink-0 rounded-[7px] object-cover" />;
  return <span className="grid size-[24px] shrink-0 place-items-center rounded-[7px] bg-[#8b5cf6] text-[11px] font-semibold text-white">{name.trim().charAt(0).toUpperCase() || '?'}</span>;
}

/** The pill itself, taking the menu's trigger props. */
const Pill = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<'button'>>(function Pill(props, ref) {
  const { organization } = useOrganization();
  const name = organization?.name ?? 'Workspace';
  return (
    <button
      {...props}
      ref={ref}
      type="button"
      aria-label="Account"
      className="flex max-w-[240px] items-center gap-[8px] rounded-[10px] px-[8px] py-[6px] text-left hover:bg-fill-2"
    >
      <Mark name={name} imageUrl={organization?.imageUrl} hasImage={organization?.hasImage} />
      {/* On a phone the workspace's mark says which it is; its name would push the search off the row. */}
      <span className="min-w-0 flex-1 truncate text-[13px] font-medium max-sm:hidden">{name}</span>
      <span className="text-label-3">
        <Icon name="chevron-up-down" size={14} />
      </span>
    </button>
  );
});

/**
 * Which workspace this is, and the account menu behind it: the shared one (`account/`), whose header is the
 * workspace switcher. This keeps only the trigger, in its place on Home's header and first page.
 */
export function WorkspaceMenu() {
  return <AccountMenu align="end" side="bottom" trigger={<Pill />} />;
}
